import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const t = a((e, l) => /* @__PURE__ */ o.jsx(
  i,
  {
    ref: l,
    ...e,
    image: (r) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...r,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M30.866 17.985a4 4 0 0 0 0-3.97l-5.714-10A4 4 0 0 0 21.679 2H10.32a4 4 0 0 0-3.473 2.015l-5.714 10a4 4 0 0 0 0 3.97l5.714 10A4 4 0 0 0 10.321 30H21.68a4 4 0 0 0 3.473-2.015zM13.252 20h-1.687v-8.402h2.648l1.793 6.158 1.781-6.158h2.649V20h-1.688v-6.404L16.88 20h-1.77l-1.857-6.398z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
t.displayName = "MetronidazoleIcon";
export {
  t as MetronidazoleIcon,
  t as default
};
//# sourceMappingURL=index.js.map
